const ferries = {
  ferry: "Ferry", // translated 
  ferries: "Mga Ferry", // translated 
  selectOriginPort: "Piliin ang pinagmulang daungan", // translated 
  selectDestPort: "Piliin ang patutunguhang daungan", // translated 
  continue: "Magpatuloy", // translated 
  viewTimetables: "Tingnan ang mga Talaorasan", // translated 
  operator: "Operator", // translated 
  cabin: "Kubin", // translated 
  cabins: "Mga Cabin", // translated 
  place: "Lugar", // translated 
  places: "Mga Lugar", // translated 
  seat: "Upuan", // translated 
  seats: "Mga Upuan", // translated 
  seating: "Pag-upo", // translated 
  deckSpace: "Espasyo sa Kubyerta", // translated 
  compulsory: "sapilitan", // translated 
  departure: "Pag-alis", // translated 
  total: "Kabuuan", // translated 
  back: "Balik", // translated 
  next: "Susunod", // translated 
  duration: "Tagal", // translated 
  return: "Pagbabalik", // translated 
  prebook: "Prebook", // translated 
  travelInfo: "Impormasyon sa Paglalakbay", // translated 
  book: "Libro", // translated 
  adults: "Mga Matanda", // translated 
  child: "Bata", // translated 
  seniors: "Mga Senior", // translated 
  senior: "Nakatatanda", // translated 
  to: "sa", // translated 
  passenger: "Pasahero", // translated 
  details: "Mga Detalye", // translated 
  currencyForTickets: "Ang pera para sa mga tiket na ito ay magiging", // translated 
  seatsError: "Hindi kapantay ng kapasidad ang bilang ng mga pasahero.", // translated 
  title: "Pamagat", // translated 
  firstName: "Pangalan", // translated 
  lastName: "Apelyido", // translated 
  email: "I-email", // translated 
  phone: "Telepono", // translated 
  dateOfBirth: "Petsa ng Kapanganakan", // translated 
  placeOfBirth: "Lugar ng Kapanganakan", // translated 
  groupLeader: "Pinuno ng Grupo", // translated 
  isRequired: "Kinakailangan", // translated 
  charactersOnly: "Mga Karakter Lamang", // translated 
  latinCharactersAndSpacesOnly: "Mga Karakter at Espasyo sa Latin Lamang", // translated 
  validEmail: "Hindi wastong email", // translated 
  atLeastOneAdult: "Kinakailangan ang kahit isang matanda.", // translated 
  atLeastOneSenior: "Kinakailangan ang kahit isang senior.", // translated 
  toastAlert: "Pakitama ang lahat ng pagkakamali sa mga form sa ibaba.", // translated 
  backToFerriesList: "Bumalik sa Listahan ng mga Ferry", // translated 
  bestPrice: "Pinakamagandang Presyo", // translated 
  fastest: "Pinakamabilis", // translated 
  beforeDeparture: "Bago ang Pag-alis", // translated 
  perPerson: "bawat tao", // translated 
  notAvailableForOnlineBooking: "Hindi available para sa online booking", // translated 
  hurryLimitedAvailability: "Bilisan mo! Limitado ang available", // translated 
  berth: "Puwesto", // translated 
  berths: "Mga tulugan", // translated 
  sumOfSelectionNotEqualToPersons:
    "Ang kabuuan ng iyong napili ay hindi katumbas ng bilang ng mga pasahero", // translated 
  attemptToBook: "Sinubukan mong mag-book ng kabuuang", // translated 
  seatsWhenYouHave: "mga upuan kapag mayroon ka", // translated 
  passengersTravelling: "mga pasaherong naglalakbay", // translated 
  withReturn: "may mga tiket pabalik", // translated 
  pleaseCorrectYourSelection: "Pakitama ang iyong napili", // translated 
  pleaseSelectUpTo: "Mangyaring pumili ng hanggang", // translated 
  accommodationTypes: "mga uri ng tirahan", // translated 
  selectionPrices: "Mga Presyo ng Pagpipilian", // translated 
  yourCurrentTicket: "Ang kasalukuyan mong uri ng tiket ay", // translated 
  upgradeTo: "Mag-upgrade sa", // translated 
  wouldYouLikeToUpgrade: "Gusto mo bang i-upgrade ang uri ng iyong tiket?", // translated 
  backToTicketTypes: "Balik sa Mga Uri ng Tiket", // translated 
  originPort: "Pinagmulang Daungan", // translated 
  destinationPort: "Daungan ng Patutunguhan", // translated 
  outboundDate: "Petsa ng Paglabas", // translated 
  inboundDate: "Petsa ng Pagpasok", // translated 
  passengers: "Mga Pasahero", // translated 
  hasReturn: "May Pagbabalik", // translated 
  passportNumber: "Numero ng Pasaporte", // translated 
  passportExpiryDate: "Petsa ng Pagtatapos ng Pasaporte", // translated 
  passportPlaceOfIssue: "Lugar ng Pag-isyu ng Pasaporte", // translated 
  passportStartDate: "Petsa ng Pagsisimula ng Pasaporte", // translated 
  cityCode: "Kodigo ng Lungsod", // translated 
};


export default ferries;
